module.exports = __webpack_public_path__ + "static/media/antiquity-music.496cb603.jpg";